import { useFormContext } from 'react-hook-form';
import type { FormSchema } from '@/app/register/schema';
import { desiredEmploymentTypes } from '@/constants/desiredEmploymentType';
import { useRouter } from 'next/navigation';
import { usePathname } from 'next/navigation';

type Props = {
  value: number;
  option: (typeof desiredEmploymentTypes)[number];
};

export default function DesiredEmploymentType({
  value,
  option: { id, name }
}: Props) {
  const { setValue } = useFormContext<FormSchema>();
  const router = useRouter();
  const pathname = usePathname();

  const handleRadioChange = () => {
    setValue('desiredEmploymentType', { id, name }, { shouldDirty: true });

    //NOTE: 背景色を被せるアニメーションが終了後、次の画面に遷移（登録導線のみ）
    if (pathname === '/register') {
      setTimeout(() => {
        router.push('register?q=phonenumber');
      }, 500);
    }
  };

  return (
    <label
      className={`relative w-full cursor-pointer overflow-hidden rounded-[12px] bg-white py-[12px] text-center after:absolute after:inset-0 after:origin-left after:rounded-[12px] after:bg-gradient-to-r after:from-primary-500 after:to-[#ff8336] hover:opacity-70 ${value === id ? 'after:scale-x-100 after:transition-transform after:duration-300 after:ease-out' : 'shadow-selection after:scale-x-0'}`}
    >
      <input
        value={id}
        type="radio"
        checked={value === id}
        onChange={handleRadioChange}
        className="hidden"
      />
      <p
        className={`relative z-10 font-semibold ${
          value === id ? 'text-white' : 'text-[#888]'
        }`}
      >
        {name}
      </p>
    </label>
  );
}
